import LOGO from '../assets/logos/logo.png';
import React from 'react';
import { Link } from 'react-router-dom';
export default function Logo({ img = LOGO, height = 'h-10', ...rest }) {
	return (
		<Link to={`/`}>
			<img
				className={height ? `w-auto ${height}` : 'h-10 w-auto'}
				src={img}
				alt='Logo'
				{...rest}
			/>
		</Link>
	);
}
